export const hasAddressChanged = (currentAddress, initialAddress) => {
  const fields = ['address_ln_1', 'address_ln_2', 'city', 'state', 'zip'];
  return fields.some((field) => currentAddress?.[field] !== initialAddress?.[field]);
};

export const hasPracticeFieldsChanged = (values, initialValues) => {
  return (
    values?.headerPhoto !== initialValues?.headerPhoto ||
    values?.dbaName !== initialValues?.dbaName ||
    values?.surchargeEnabled !== initialValues?.surchargeEnabled ||
    values?.surchargeAmount !== initialValues?.surchargeAmount ||
    values?.timezone !== initialValues?.timezone ||
    JSON.stringify(values?.displaySettings) !== JSON.stringify(initialValues?.displaySettings) ||
    JSON.stringify(values?.availableTimes) !== JSON.stringify(initialValues?.availableTimes)
  );
};

export const getUpdateFields = (values, initialValues) => {
  const updateFields = {};

  if (values?.headerPhoto !== initialValues?.headerPhoto) {
    updateFields.header_photo = values?.headerPhoto;
  }
  if (values?.dbaName !== initialValues?.dbaName) {
    updateFields.dba_name = values?.dbaName;
  }
  if (JSON.stringify(values?.displaySettings) !== JSON.stringify(initialValues?.displaySettings)) {
    updateFields.display_settings = values?.displaySettings;
  }
  if (values?.surchargeEnabled !== initialValues?.surchargeEnabled) {
    updateFields.surcharge_enabled = values?.surchargeEnabled;
    updateFields.surcharge_percentage = values?.surchargeEnabled
      ? parseFloat(values?.surchargeAmount / 100)
      : 0;
  } else if (values?.surchargeAmount !== initialValues?.surchargeAmount) {
    updateFields.surcharge_percentage = values?.surchargeEnabled
      ? parseFloat(values?.surchargeAmount / 100)
      : 0;
  }
  if (
    values?.availableTimes &&
    JSON.stringify(values?.availableTimes) !== JSON.stringify(initialValues?.availableTimes)
  ) {
    updateFields.available_times = JSON.stringify(values.availableTimes);
  }
  if (values?.timezone !== initialValues?.timezone) {
    updateFields.timezone = values.timezone;
  }

  return updateFields;
};
